<div class="dashboard-content-sec">
    <div class="card">
        <app-breadcrumb [crumbList] = "crumbList"></app-breadcrumb>
        <div class="user-heading-sec">
            <p>{{this.total}} Clients</p> 
        </div>
        <div class="d-inline">
          <div style='width: 120px' class="d-inline">
            <a href="javascript:void(0)" [routerLink]="['/admins/client']" 
              class="btn btn-default fa fa-building">
                Add Client
            </a>                        
          </div>
          <div class="d-inline float-right ml-2">
            <!-- <input title="Import Clients" type="button" class="btn btn-default" value="Choose File(s)" onclick="document.getElementById('file').click();" /> -->
            <a title="Import Clients" type="file" class="btn client-download" onclick="document.getElementById('file').click();">
                   <i class="fa fa-file-upload"></i>
            </a>
            <input type="file" style="display:none;" id="file" (change)="getFile($event)"
                   name="file" multiple/>            

            <!-- <input type="button" class="btn btn-default" value="Choose File(s)" onclick="document.getElementById('file').click();" />
            <input type="file" style="display:none;" id="file" 
                   (change)="getFiles($event)"                       
                   name="file" multiple/> -->

          </div>


          <div class="d-inline float-right">
            <a (click)="downloadClients()" target="_blank" class="btn client-download" title="Download Clients">
                <i class="fa fa-download"></i>
            </a>
          </div>


        </div>

        <div class="table-responsive">
          <div class="loader" *ngIf="showloader">
            <img src="assets/images/loader.gif" alt="">
          </div>
            <table class="table user-table table-striped">
                <thead>
                    <tr>
                        <th *ngFor="let header of row_header;let i = index" (click)="tableSort(i)">
                            <i *ngIf="header.sort == 'asc' && header.value != ''" class="fa fa-sort-up"></i>
                            <i *ngIf="header.sort == 'desc' && header.value != ''" class="fa fa-sort-down"></i>
                            <i *ngIf="header.sort == null && header.value != ''" class="fa fa-sort"></i>
                            {{header.text}}
                        </th>
                      <th>Action</th>
                    </tr>
                    <tr>
                        <th>
                            <div class="subject-search">
                                <input (change)="filterByClient($event)"/>
                            </div>
                        </th>
                        <th>
                            <div class="subject-search">
                                <input (change)="filterByContactName($event)"/>
                            </div>
                        </th>
                        <th *ngIf="curr_user_id.RoleType !== 3">
                            <div class="select-options">
                                <select (change)="filterByPartner($event)" class="select-options">
                                    <option value="">--- Filter ---</option>
                                    <option id="{{part.ID}}" value="{{part.ID}}" *ngFor="let part of partners">{{part.CompanyName}}</option>
                                </select>
                            </div>
                        </th>
                        <th>&nbsp;</th>
                        <th>&nbsp;</th>
                        <th>&nbsp;</th>
                    </tr>
                </thead>

                <tbody>
                    <ng-container *ngFor="let client of clients">
                        <tr>
                        
                            <td>
                                <a href="javascrpt:void(0);" [routerLink]="['/admins/client',client.ID]">{{client.ClientName}}</a>
                            </td>
                            
                            <td>
                                <a href="javascrpt:void(0);" [routerLink]="['/admins/client',client.ID]">{{client.ContactName}}</a>
                            </td>

                            <td *ngIf="curr_user_id.RoleType !== 3">
                                <a href="javascrpt:void(0);" [routerLink]="['/admins/client',client.ID]">{{client.PartnerName}}</a>
                            </td>
        
                            <td>
                                <a href="javascrpt:void(0);" [routerLink]="['/admins/client',client.ID]">{{client.Active==1 ? "Active" : 'Inactive'}}</a>
                            </td>
        
                            <td>
                            <a href="javascrpt:void(0);" [routerLink]="['/admins/client',client.ID]">{{client.BusinessSummary ? client.BusinessSummary.substring(0,30) : '-'}}</a>
                            </td>
        
                            <td>
                                <div ngbDropdown placement="bottom-right" class="d-inline-block">
                                    <button class="" id="dropdownBasic1" ngbDropdownToggle><i class="fa fa-ellipsis-h" aria-hidden="true"></i>
                                    </button>
                                    <div class="right" ngbDropdownMenu aria-labelledby="dropdownBasic1">
                                        <button class="dropdown-item" [routerLink]="['/admins/client',client.ID]">Edit</button>
                                        <button class="dropdown-item" (click)="deleteUser(client.ID)">Delete</button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>

                <ng-container *ngIf="clients?.length == 0">
                  <tr><td colspan="5">No Result Found</td></tr>
                </ng-container>



            </table>
            <div class="has-text-centered align-items-end">
                <ul *ngIf="pager.pages && pager.pages.length && pager.pages.length>1" class="pagination">
                    <li *ngIf="pager.currentPage !== 1" [ngClass]="{disabled:pager.currentPage === 1}">
                        <a (click)="setPage(1)">First</a>
                    </li>
                    <li *ngIf="pager.currentPage !== 1" [ngClass]="{disabled:pager.currentPage === 1}">
                        <a (click)="setPage(pager.currentPage - 1)">Previous</a>
                    </li>
                    <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                        <a (click)="setPage(page)">{{page}}</a>
                    </li>
                    <li *ngIf="pager.currentPage !== pager.totalPages" [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                        <a (click)="setPage(pager.currentPage + 1)">Next</a>
                    </li>
                    <li *ngIf="pager.currentPage !== pager.totalPages" [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                        <a (click)="setPage(pager.totalPages)">Last</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
